import * as React from 'react';
import { Translate } from 'react-localize-redux';
import RepairReleaseCtrl from '@webapp/controllers/release/repair-release';

interface StreamingPlatformsPageProps {
  className?: string;
}

export const StreamingPlatformsPage: React.FC<StreamingPlatformsPageProps> = ({
  className,
}) => {
  return (
    <RepairReleaseCtrl
      className={className}
      title={<Translate id="RELEASE.STREAMING.TITLE" />}
    />
  );
};

export default StreamingPlatformsPage;
